var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.135.941c-2.211 0-4.01 1.8-4.01 4.012v5.728c0 2.211 1.8 4.01 4.011 4.01h5.729c2.21 0 4.01-1.8 4.01-4.01V4.95c0-2.21-1.8-4.01-4.011-4.01zm6.99 2.2a.55.55 0 1 1 0 1.1.55.55 0 0 1 0-1.1M7 4.241a3.58 3.58 0 0 1 3.575 3.575A3.58 3.58 0 0 1 7 11.391a3.58 3.58 0 0 1-3.575-3.575A3.58 3.58 0 0 1 7 4.241m0 1.1a2.475 2.475 0 1 0 0 4.95 2.475 2.475 0 0 0 0-4.95"
  })));
};
export default SvgInstagram;